export default __webpack_public_path__ + "static/media/Chef.87cc8f97.jpg";